export default __webpack_public_path__ + "static/media/clip-icon-green.72266f16.svg";